import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useCandidateAuth } from "@/context/CandidateAuthContext";

export default function CandidateLoginPage() {
  const { requestOtp, verifyOtp, loading, error } = useCandidateAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/candidat/mon-cv";

  const [step, setStep] = useState("email"); // "email" | "otp"
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [localError, setLocalError] = useState(null);

  const handleRequestOtp = async (e) => {
    e.preventDefault();
    setLocalError(null);
    const result = await requestOtp(email);
    if (result.ok) {
      setStep("otp");
    } else {
      setLocalError(result.error);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLocalError(null);
    const result = await verifyOtp(email, otp);
    if (result.ok) {
      navigate(from, { replace: true });
    } else {
      setLocalError(result.error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-12 h-12 rounded-2xl bg-violet-600 flex items-center justify-center text-white font-bold text-xl mx-auto mb-3">
            L
          </div>
          <h1 className="text-xl font-bold text-white">Accès Espace Candidat</h1>
          <p className="text-slate-400 text-sm mt-1">
            {step === "email"
              ? "Entrez votre email pour recevoir un code d'accès"
              : `Code envoyé à ${email}`}
          </p>
        </div>

        <div className="bg-[#14183a] border border-slate-700/50 rounded-2xl p-6 shadow-xl">
          {step === "email" ? (
            <form onSubmit={handleRequestOtp} className="space-y-4">
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Adresse email</label>
                <input
                  type="email"
                  autoFocus
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.fr"
                  className="w-full px-4 py-3 bg-[#0b0e1a] border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-violet-500 focus:outline-none transition-colors"
                />
              </div>

              {(localError || error) && (
                <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
                  {localError || error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-violet-600 hover:bg-violet-700 text-white rounded-xl font-semibold transition-colors disabled:opacity-50"
              >
                {loading ? "Envoi..." : "Recevoir mon code"}
              </button>
            </form>
          ) : (
            <form onSubmit={handleVerifyOtp} className="space-y-4">
              <div>
                <label className="block text-sm text-slate-400 mb-1.5">Code à 6 chiffres</label>
                <input
                  type="text"
                  autoFocus
                  required
                  maxLength={6}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  placeholder="000000"
                  className="w-full px-4 py-3 bg-[#0b0e1a] border border-slate-600 rounded-xl text-white placeholder-slate-500 focus:border-violet-500 focus:outline-none transition-colors tracking-widest text-center text-xl font-mono"
                />
              </div>

              {(localError || error) && (
                <div className="text-red-400 text-sm bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-2">
                  {localError || error}
                </div>
              )}

              <button
                type="submit"
                disabled={loading || otp.length !== 6}
                className="w-full py-3 bg-violet-600 hover:bg-violet-700 text-white rounded-xl font-semibold transition-colors disabled:opacity-50"
              >
                {loading ? "Vérification..." : "Accéder à mon espace"}
              </button>

              <button
                type="button"
                onClick={() => { setStep("email"); setOtp(""); setLocalError(null); }}
                className="w-full text-slate-400 hover:text-white text-sm transition-colors"
              >
                ← Changer d'email
              </button>
            </form>
          )}
        </div>

        <p className="text-center text-xs text-slate-600 mt-6">
          Code valide 15 minutes · 3 tentatives max
        </p>
      </div>
    </div>
  );
}
